import React, { useState } from 'react';
import { Box, Button, TextField, Typography } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';

function ConsoleAccountSection({ boostInput, onUpdate, fieldName = 'user_id' }) {
  const [path, setPath] = useState('in_app_users');
  const [value, setValue] = useState('');
  const [boost, setBoost] = useState(1);

  const handleAction = (action) => {
    const trimmedPath = path.trim();
    const trimmedValue = value.trim();

    if (!trimmedPath || !trimmedValue) {
      return;
    }

    const updateData = {
      action,
      type: 'console_account',
      field: fieldName,
      path: trimmedPath,
      value: trimmedValue,
    };

    if (boostInput && action === 'boost') {
      updateData.boost = boost;
    }

    onUpdate(updateData);
  };

  return (
    <Box>
      <Typography variant="body2" sx={{ mb: 2 }} color="text.secondary">
        Match this result field against a value in the authenticated console account document.
      </Typography>

      <TextField
        fullWidth
        sx={{ mb: 2 }}
        label="Account path"
        value={path}
        onChange={(e) => setPath(e.target.value)}
        helperText="Dot-notation path, for example in_app_users or preferences.wallets"
      />

      <TextField
        fullWidth
        sx={{ mb: 2 }}
        label="Value"
        value={value}
        onChange={(e) => setValue(e.target.value)}
        helperText={`Compared against ${fieldName}`}
      />

      {boostInput && (
        <TextField
          fullWidth
          sx={{ mb: 2 }}
          label="Boost"
          type="number"
          value={boost}
          onChange={(e) => setBoost(parseFloat(e.target.value) || 1)}
          inputProps={{ min: 0, step: 0.1 }}
        />
      )}

      <Box sx={{ display: 'flex', gap: 2, justifyContent: 'flex-end' }}>
        <Button variant="contained" color="primary" onClick={() => handleAction('include')}>
          <AddIcon />
        </Button>
        {boostInput && (
          <Button variant="contained" color="success" onClick={() => handleAction('boost')}>
            <TrendingUpIcon />
          </Button>
        )}
        <Button variant="contained" color="error" onClick={() => handleAction('exclude')}>
          <RemoveIcon />
        </Button>
      </Box>
    </Box>
  );
}

export default ConsoleAccountSection;
